import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "project-container" }
const _hoisted_2 = { class: "header" }
const _hoisted_3 = { class: "flex-container" }
const _hoisted_4 = { class: "image-container" }
const _hoisted_5 = ["src"]
const _hoisted_6 = { class: "text-container" }
const _hoisted_7 = { class: "subtitle" }
const _hoisted_8 = { class: "about-project" }
const _hoisted_9 = { class: "content-grid" }
const _hoisted_10 = { class: "text-block" }
const _hoisted_11 = ["innerHTML"]
const _hoisted_12 = ["innerHTML"]
const _hoisted_13 = { class: "frontend-details" }
const _hoisted_14 = { class: "tech-grid" }
const _hoisted_15 = { class: "tech-card" }
const _hoisted_16 = { class: "feature-list" }
const _hoisted_17 = { class: "feature-item" }
const _hoisted_18 = ["innerHTML"]
const _hoisted_19 = { class: "feature-item" }
const _hoisted_20 = ["innerHTML"]
const _hoisted_21 = { class: "feature-item" }
const _hoisted_22 = ["innerHTML"]
const _hoisted_23 = { class: "image-wrapper-bordered" }
const _hoisted_24 = ["src"]
const _hoisted_25 = { class: "architecture-details" }
const _hoisted_26 = { class: "tech-grid" }
const _hoisted_27 = { class: "tech-card" }
const _hoisted_28 = { class: "feature-list" }
const _hoisted_29 = { class: "feature-item" }
const _hoisted_30 = ["innerHTML"]
const _hoisted_31 = { class: "feature-item" }
const _hoisted_32 = ["innerHTML"]
const _hoisted_33 = { class: "tech-card" }
const _hoisted_34 = { class: "feature-list" }
const _hoisted_35 = { class: "feature-item" }
const _hoisted_36 = ["innerHTML"]
const _hoisted_37 = { class: "visuals-section" }
const _hoisted_38 = { class: "visuals-grid" }
const _hoisted_39 = { class: "visual-card" }
const _hoisted_40 = { class: "image-wrapper" }
const _hoisted_41 = ["src"]
const _hoisted_42 = { class: "tech-card" }
const _hoisted_43 = { class: "feature-list" }
const _hoisted_44 = { class: "feature-item" }
const _hoisted_45 = ["innerHTML"]
const _hoisted_46 = { class: "feature-item" }
const _hoisted_47 = ["innerHTML"]
const _hoisted_48 = { class: "feature-item" }
const _hoisted_49 = ["innerHTML"]
const _hoisted_50 = { class: "technical-details" }
const _hoisted_51 = { class: "competencies-grid" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_InfraCompetencyCard = _resolveComponent("InfraCompetencyCard")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("header", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("img", {
            src: require('@/assets/image/portfolio-screen.png'),
            alt: "Logo Portfolio",
            class: "header-image",
            loading: "lazy"
          }, null, 8, _hoisted_5)
        ]),
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("h1", null, _toDisplayString(_ctx.$t('portfolio.title')), 1),
          _createElementVNode("p", _hoisted_7, _toDisplayString(_ctx.$t('portfolio.subtitle')), 1)
        ])
      ])
    ]),
    _createElementVNode("section", _hoisted_8, [
      _createElementVNode("h2", null, _toDisplayString(_ctx.$t('portfolio.aboutTitle')), 1),
      _createElementVNode("div", _hoisted_9, [
        _createElementVNode("div", _hoisted_10, [
          _createElementVNode("p", {
            innerHTML: _ctx.$t('portfolio.about1')
          }, null, 8, _hoisted_11),
          _createElementVNode("p", {
            innerHTML: _ctx.$t('portfolio.about2')
          }, null, 8, _hoisted_12)
        ]),
        _cache[0] || (_cache[0] = _createStaticVNode("<div class=\"highlight-box\" data-v-1ac0a614><div class=\"stat-item\" data-v-1ac0a614><span class=\"mdi mdi-vuejs stat-icon\" data-v-1ac0a614></span><span class=\"stat-text\" data-v-1ac0a614>Vue.js 3 SPA</span></div><div class=\"stat-item\" data-v-1ac0a614><span class=\"mdi mdi-language-typescript stat-icon\" data-v-1ac0a614></span><span class=\"stat-text\" data-v-1ac0a614>TypeScript Core</span></div><div class=\"stat-item\" data-v-1ac0a614><span class=\"mdi mdi-kubernetes stat-icon\" data-v-1ac0a614></span><span class=\"stat-text\" data-v-1ac0a614>K8s Deployment</span></div></div>", 1))
      ])
    ]),
    _createElementVNode("section", _hoisted_13, [
      _createElementVNode("h2", null, _toDisplayString(_ctx.$t('portfolio.frontendTitle')), 1),
      _createElementVNode("div", _hoisted_14, [
        _createElementVNode("div", _hoisted_15, [
          _cache[4] || (_cache[4] = _createElementVNode("div", { class: "tech-header" }, [
            _createElementVNode("span", { class: "mdi mdi-layers-outline tech-icon" }),
            _createElementVNode("h4", null, "Tech Stack & Architecture")
          ], -1)),
          _createElementVNode("div", _hoisted_16, [
            _createElementVNode("div", _hoisted_17, [
              _cache[1] || (_cache[1] = _createElementVNode("span", { class: "mdi mdi-check-circle-outline feature-icon" }, null, -1)),
              _createElementVNode("p", {
                innerHTML: _ctx.$t('portfolio.frontend1')
              }, null, 8, _hoisted_18)
            ]),
            _createElementVNode("div", _hoisted_19, [
              _cache[2] || (_cache[2] = _createElementVNode("span", { class: "mdi mdi-palette-swatch-outline feature-icon" }, null, -1)),
              _createElementVNode("p", {
                innerHTML: _ctx.$t('portfolio.frontend2')
              }, null, 8, _hoisted_20)
            ]),
            _createElementVNode("div", _hoisted_21, [
              _cache[3] || (_cache[3] = _createElementVNode("span", { class: "mdi mdi-animation-outline feature-icon" }, null, -1)),
              _createElementVNode("p", {
                innerHTML: _ctx.$t('portfolio.frontend3')
              }, null, 8, _hoisted_22)
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_23, [
          _createElementVNode("img", {
            src: require('@/assets/image/portfolio-screen.png'),
            alt: "Portfolio Interface Preview",
            class: "doc-image-contained",
            loading: "lazy"
          }, null, 8, _hoisted_24)
        ])
      ])
    ]),
    _createElementVNode("section", _hoisted_25, [
      _createElementVNode("h2", null, _toDisplayString(_ctx.$t('portfolio.gitopsTitle')), 1),
      _createElementVNode("div", _hoisted_26, [
        _createElementVNode("div", _hoisted_27, [
          _cache[7] || (_cache[7] = _createElementVNode("div", { class: "tech-header" }, [
            _createElementVNode("span", { class: "mdi mdi-gitlab tech-icon" }),
            _createElementVNode("h4", null, "CI Pipeline (GitLab)")
          ], -1)),
          _createElementVNode("div", _hoisted_28, [
            _createElementVNode("div", _hoisted_29, [
              _cache[5] || (_cache[5] = _createElementVNode("span", { class: "mdi mdi-hammer-wrench feature-icon" }, null, -1)),
              _createElementVNode("p", {
                innerHTML: _ctx.$t('portfolio.gitops1')
              }, null, 8, _hoisted_30)
            ]),
            _createElementVNode("div", _hoisted_31, [
              _cache[6] || (_cache[6] = _createElementVNode("span", { class: "mdi mdi-docker feature-icon" }, null, -1)),
              _createElementVNode("p", {
                innerHTML: _ctx.$t('portfolio.gitops3')
              }, null, 8, _hoisted_32)
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_33, [
          _cache[10] || (_cache[10] = _createElementVNode("div", { class: "tech-header" }, [
            _createElementVNode("span", { class: "mdi mdi-sync tech-icon" }),
            _createElementVNode("h4", null, "CD Workflow (ArgoCD)")
          ], -1)),
          _createElementVNode("div", _hoisted_34, [
            _createElementVNode("div", _hoisted_35, [
              _cache[8] || (_cache[8] = _createElementVNode("span", { class: "mdi mdi-refresh feature-icon" }, null, -1)),
              _createElementVNode("p", {
                innerHTML: _ctx.$t('portfolio.gitops2')
              }, null, 8, _hoisted_36)
            ]),
            _cache[9] || (_cache[9] = _createElementVNode("div", { class: "feature-item" }, [
              _createElementVNode("span", { class: "mdi mdi-shield-check-outline feature-icon" }),
              _createElementVNode("p", null, "Validation automatique de l'état du cluster via GitOps.")
            ], -1))
          ])
        ])
      ])
    ]),
    _createElementVNode("section", _hoisted_37, [
      _cache[16] || (_cache[16] = _createElementVNode("h2", null, "Infrastructure & GitOps View", -1)),
      _createElementVNode("div", _hoisted_38, [
        _createElementVNode("div", _hoisted_39, [
          _cache[11] || (_cache[11] = _createElementVNode("h3", null, "ArgoCD Dashboard", -1)),
          _createElementVNode("div", _hoisted_40, [
            _createElementVNode("img", {
              src: require('@/assets/image/argocd-portfolio.png'),
              alt: "ArgoCD View",
              class: "doc-image",
              loading: "lazy"
            }, null, 8, _hoisted_41)
          ])
        ]),
        _createElementVNode("div", _hoisted_42, [
          _cache[15] || (_cache[15] = _createElementVNode("div", { class: "tech-header" }, [
            _createElementVNode("span", { class: "mdi mdi-kubernetes tech-icon" }),
            _createElementVNode("h4", null, "Cloud-Native Stack")
          ], -1)),
          _createElementVNode("div", _hoisted_43, [
            _createElementVNode("div", _hoisted_44, [
              _cache[12] || (_cache[12] = _createElementVNode("span", { class: "mdi mdi-security feature-icon" }, null, -1)),
              _createElementVNode("p", {
                innerHTML: _ctx.$t('portfolio.k8s1')
              }, null, 8, _hoisted_45)
            ]),
            _createElementVNode("div", _hoisted_46, [
              _cache[13] || (_cache[13] = _createElementVNode("span", { class: "mdi mdi-heart-pulse feature-icon" }, null, -1)),
              _createElementVNode("p", {
                innerHTML: _ctx.$t('portfolio.k8s2')
              }, null, 8, _hoisted_47)
            ]),
            _createElementVNode("div", _hoisted_48, [
              _cache[14] || (_cache[14] = _createElementVNode("span", { class: "mdi mdi-chart-areaspline feature-icon" }, null, -1)),
              _createElementVNode("p", {
                innerHTML: _ctx.$t('portfolio.k8s3')
              }, null, 8, _hoisted_49)
            ])
          ])
        ])
      ])
    ]),
    _createElementVNode("section", _hoisted_50, [
      _createElementVNode("h2", null, _toDisplayString(_ctx.$t('portfolio.learningsTitle')), 1),
      _createElementVNode("div", _hoisted_51, [
        _createVNode(_component_InfraCompetencyCard, {
          icon: "mdi-rocket-launch-outline",
          title: "CI/CD Pipelines",
          description: _ctx.$t('portfolio.learning1')
        }, null, 8, ["description"]),
        _createVNode(_component_InfraCompetencyCard, {
          icon: "mdi-kubernetes",
          title: "K8s Manifests",
          description: _ctx.$t('portfolio.learning2')
        }, null, 8, ["description"]),
        _createVNode(_component_InfraCompetencyCard, {
          icon: "mdi-certificate-outline",
          title: "Cert-Manager",
          description: _ctx.$t('portfolio.learning3')
        }, null, 8, ["description"]),
        _createVNode(_component_InfraCompetencyCard, {
          icon: "mdi-sync",
          title: "GitOps Automation",
          description: _ctx.$t('portfolio.learning4')
        }, null, 8, ["description"])
      ])
    ])
  ]))
}